

interface Props {
    children: React.ReactNode;
}

export function ToolTipIcon({
    children,
}: Props) {
    return (
        <div className='tooltip-icon'>
            <span className='icon'>?</span>
            <span className='tooltip-text'>{children}</span>
        </div>
    )
}
